import React from "react";
import { Wheat, Droplets, HeartHandshake } from "lucide-react";
const values = [{
  icon: Wheat,
  title: "Recuperación de Aceite",
  description: "Recolectamos aceites de cocina usados y biomasa local en toda Cuba, transformando residuos en energía limpia y renovable."
}, {
  icon: Droplets,
  title: "Procesamiento Industrial",
  description: "Nuestra tecnología de vanguardia convierte materias primas orgánicas en biodiesel de alta calidad con estándares internacionales."
}, {
  icon: HeartHandshake,
  title: "Independencia Energética",
  description: "Reducimos la dependencia de Cuba del petróleo importado, fortaleciendo la soberanía energética mediante recursos propios."
}];
export default function CoreEnergyPillars() {
  return <section data-section-id="223778" id="core-energy-pillars" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-3 md:gap-12 lg:gap-20">
          {values.map((value, i) => {
          const Icon = value.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group transition-transform duration-300 hover:scale-102">
                <div className="mb-8 flex h-24 w-24 items-center justify-center rounded-lg bg-card shadow-md border border-border/50 transition-all duration-300 group-hover:shadow-lg group-hover:ring-1 group-hover:ring-primary/20">
                  <Icon className={`h-10 w-10 ${i === 0 ? "text-green-600" : i === 1 ? "text-slate-500" : "text-yellow-500"}`} strokeWidth={1.5} aria-hidden="true" />
                </div>
                <h3 className="font-default mb-4 text-[clamp(1.75rem,5vw,2.25rem)] font-bold tracking-tight text-foreground">
                  {value.title}
                </h3>
                <p className="font-default text-base leading-relaxed text-muted-foreground">
                  {value.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}